<!-- <div fxLayout.gt-xs="row" fxLayout.xs="column" fxLayoutAlign="space-evenly stretch" class="home-promotion p-20" fxLayoutGap="20px">
     , 

    
  </div> -->
<div class="row">

    <div class="col-md-12" *ngIf="paygname">
        <div class="text-center">Copyright &copy; {{settings.getAppSetting('year')}} - {{ settings.getAppSetting('name') }}</div>
      </div>
      <div class="col-md-12" *ngIf="resellername">
        <div class="text-center">Copyright &copy; {{settings.getAppSetting('year')}} - {{whitelabelresellername  }}.All Rights Reserved.</div>
      </div>
</div>